// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qcmq","col":"styles_col__3-alr"};